import jQuery from 'jquery';
import MouseFollower from "mouse-follower";
import { gsap } from "gsap";

MouseFollower.registerGSAP(gsap);

export default class MouseCursor {

	//$;
	static _type;

	constructor( type ) {

		this._type = type;
		this.device_width = window.innerWidth;

		this.cursor = new MouseFollower(this.getMouseFollowerOptions());

		this.initEvents();

		return this.cursor;

	}

	getMouseFollowerOptions() {

		return {
			el: null,
			container: document.body,
			className: 'mf-cursor',
			innerClassName: 'mf-cursor-inner',
			textClassName: 'mf-cursor-text',
			mediaClassName: 'mf-cursor-media',
			mediaBoxClassName: 'mf-cursor-media-box',
			//iconSvgClassName: 'mf-svgsprite',
			//iconSvgNamePrefix: '-',
			//iconSvgSrc: '',
			dataAttr: 'cursor',
			hiddenState: '-hidden',
			textState: '-text',
			iconState: '-icon',
			activeState: '-active',
			mediaState: '-media',
			stateDetection: {
				'-pointer': 'a,button',
				'-hidden': 'iframe',
				'-video': '.cursor-interactive-video'
			},
			visible: false,
			visibleOnState: false,
			speed: 0.25,
			ease: 'expo.out',
			overwrite: true,
			skewing: 0,
			skewingText: 2,
			skewingIcon: 2,
			skewingMedia: 2,
			skewingDelta: 0.001,
			skewingDeltaMax: 0.15,
			stickDelta: 0.15,
			showTimeout: 20,
			hideOnLeave: true,
			hideTimeout: 300,
			hideMediaTimeout: 300
		}

	}

	initCustomCursor() {

		this.myCursor = document.body.querySelectorAll(".mouseCursor");
		if (this.myCursor.length) {

			if (document.body) {
				
				this.cursorInner = document.querySelector(".cursor-inner"),
				this.cursorOuter = document.querySelector(".cursor-outer");
				let n, 
					i = 0,
					o = !1;
				(window.onmousemove = (s) => {
					o ||
						(this.cursorOuter.style.transform = "translate(" + s.clientX + "px, " + s.clientY + "px)"),
						(this.cursorInner.style.transform = "translate(" + s.clientX + "px, " + s.clientY + "px)"),
						(n = s.clientY),
						(i = s.clientX);
				});
				(this.cursorInner.style.visibility = "visible");
				//(this.cursorOuter.style.visibility = "visible");
			}

			this.initEvents();
		}
	}

	initEvents() {

		console.info('[MouseCursor.js] EVENTS['+this._type+']');

		/** /
		jQuery('.pirate-image').on('mouseenter', (evt) => {
			evt.preventDefault();

			const target = evt.currentTarget;
			this.cursor.setText('<span class="material-symbols-outlined">eyeglasses</span>');

			if( target ) {
				target.classList.add('no-cursor-override');

			}
		});
		/**/

		/** /
		jQuery('.news-card').on('mouseenter', (evt) => {
			evt.preventDefault();
			//console.log('PIRATE HOVER ON');
			this.cursor.setText('READ MORE');
		});
		
		jQuery('.elementor-widget-theme-post-featured-image').on('mouseenter', (evt) => {
			evt.preventDefault();
			//console.log('PIRATE HOVER ON');
			this.cursor.setText('DISCOVER MORE');
		});
		
		/**/

		jQuery('.elementor-widget-theme-post-featured-image, .news-card').on('mouseleave', (evt) => {
			evt.preventDefault();
			const target = evt.currentTarget;

			if( target ) {
				target.classList.remove('no-cursor-override');

			}

			this.cursor.removeText();
		});

	}

	initEvents2() {

		jQuery(".cursor-interactive-video, .grid-case-study-thumbnail, .news-card").on("mouseenter", (evt) => {

			const target = evt.currentTarget;

			if( target ) {
				target.classList.add('no-cursor-override');

				if( target.classList.contains('elementor-video') ) {
					this.cursorInner.querySelector('span').innerText = 'PLAY';
				} else if( target.classList.contains('grid-case-study-thumbnail') ) {
					this.cursorInner.querySelector('span').innerText = 'DISCOVER';
				} else {
					this.cursorInner.querySelector('span').innerText = 'MORE';
				}

				this.cursorInner.classList.add("cursor-hover");
			}

			this.myCursor.forEach((elem)=>{
				elem.classList.add('cursor-big');
			});

		});
		jQuery(".cursor-interactive-video, .grid-case-study-thumbnail, .news-card").on("mouseleave", (evt) => {
			
			if( (jQuery(this).is("a", "button") && jQuery(this).closest(".cursor-pointer").length) ) {} else {
				this.cursorInner.classList.remove("cursor-hover"); 
				//this.cursorOuter.classList.remove("cursor-hover");

				const target = evt.currentTarget;

				if( target ) {
					target.classList.remove('no-cursor-override');
				}
			}

			this.myCursor.forEach((elem)=>{
				elem.classList.remove('cursor-big');
			})
		});

		/** /
		if (this.device_width > 576) {
			const workContentItem = document.querySelectorAll(".work__item-list");
	
			function followContentCursor(event, workContentItem) {
				const contentBox2 = workContentItem.getBoundingClientRect();
				const dx = event.clientX - contentBox2.x;
				const dy = event.clientY - contentBox2.y;
				workContentItem.children[1].style.transform = `translate(${dx}px, ${dy}px)`;
			}
			workContentItem.forEach((item, i) => {
				item.addEventListener("mousemove", (event) => {
					setInterval(followContentCursor(event, item), 1000);
				});
			});
		}
		/**/

	}

	updatePosition(pos) {
		this.cursorOuter.style.transform = "translate(" + pos.x + "px, " + pos.y + "px)";
		this.cursorInner.style.transform = "translate(" + pos.x + "px, " + pos.y + "px)";
	}
}